
const range = (stop: number) => [...Array<number>(stop)].map((_, i) => i)

export default range